import { Config } from '../other';

export const getApps = () => {
  return {
    status: 200,
    message: 'Ok',
    data: [
      {
        Appid: Config.ECOMMAPP_APP_ID,
        Name: 'Ecomm-app',
        Country: 'ARG',
        Type: 'shipping',
        Status: 'ready',
        Created_at: '2022-08-05T20:30:19Z,',
        Updated_at: '2022-08-05T20:30:19Z,',
        Logo: 'https://dk0k1i3js6c49.cloudfront.net/applications/logos/ecommapp-logo.png',
        Redirect_url: 'https://www.ecomm-app.com',
      },
    ],
  };
};

export const getAppsActives = () => {
  return {
    status: 200,
    message: 'Ok',
    data: {
      applications: [Config.ECOMMAPP_APP_ID],
    },
  };
};
